module.exports = __webpack_public_path__ + "static/media/logo.674dea0b.svg";